<template>
    <v-container>
        <v-row align="center" justify="center" class="justify-center">
            <v-col class="px-5">
                <date-time-relative-input v-model="begin"/>
            </v-col>
            <v-col class="px-5">
                <date-time-relative-input v-model="end"/>
            </v-col>
        </v-row>
        <v-btn style=" width: 100%;"
               color="blue" class="white--text"
               @click="confirm()"
               :disabled="!isValid"
        >
            Apply
        </v-btn>
    </v-container>
</template>

<script>
    import {mapActions, mapGetters} from "vuex";
    import {SEARCH_NS} from "@/store/modules/search/constants";
    import DateTimeRelativeInput from "@/components/home/date/DateTimeRelativeInput";

    export default {
        name: "DateTimeRelative",
        components: {DateTimeRelativeInput},
        data() {
            return {
                begin: this.beginDate,
                end: this.endDate
            }
        },
        computed: {
            ...mapGetters(SEARCH_NS, [
                'beginDate',
                'endDate'
            ]),
            isValid() {
                return this.begin.isSameOrBefore(this.end);
            }
        },
        watch: {
            beginDate() {
                this.begin = this.beginDate;
            },
            endDate() {
                this.end = this.endDate;
            }
        },
        methods: {
            ...mapActions(SEARCH_NS, [
                'toggleDateTimePanel',
                'updatePeriod'
            ]),
            confirm() {
                this.updatePeriod({
                    begin: this.begin,
                    end: this.end
                });
                this.toggleDateTimePanel();
            }
        },
        created() {
            this.begin = this.beginDate;
            this.end = this.endDate;
        }
    }
</script>